import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * マニュアル API 操作クラス
 */
export default class Manuals {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * GET Manuals
   */
  public async get(userStore: LoginUser): Promise<Array<ManualsGetModel>> {
    const formatParams: any = {
      facilityId: userStore.facility.id
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.Manuals, formatParams);
    const response = await this.commonService.executeGet<Array<ManualsGetModel>>(userStore, requestUrl, this.constructor.name, {}, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

/**
 * マニュアル
 */
export interface ManualsGetModel {
  /** 一意なID */
  id: number;
  /** PDF格納先S3URL */
  url: string;
  /** タイトル */
  title: string;
  /** マニュアル概要 */
  description: string;
  /** 作成日 */
  created: number;
  /** 更新日 */
  updated: number;
  /** 論理削除フラグ */
  deleteFlag: boolean;
  /** 利用プラン */
  plan: number;
  /** アイコン格納先S3URL */
  iconUrl: string;
  /** マニュアルの並び順 */
  orderIndex: number;
}
